import humps from 'humps';
import api from '@/service/leads/index';
import createStore from '@/store/base/create-store';
const { state, actions, mutations } = createStore(api);
import { isWX } from '@/util/browser.js';
import { UrlConfig } from '@/util/env.js';
import { buildUrlWithQuery } from '@/util/url.js';
import { INVITATION_CHANNEL_CODE } from '@/config/enums';

const DEFAULT_CAR_MODEL = 'es7';
const tempState = {
    redirectUrl: '', // 重定向地址
    // 页面配置
    pageOption: {
        accountId: '', // 邀请人accountId，无需加密
        userAccount: '', // 邀请人accountId，无需加密 兼容参数key
        activityId: '', // 志愿者活动id
        uniqueAccount: '', // 邀请人accountId，加密key
        uniqueAccountDecodeType: 'app', // 解析 加密accountId的方式，app/vom
        campaignSourceCode: '', // 来源code
        title: '预留信息', // 页面title
        activity: '', // 活动内容
        bannerImg: '', // bannerImg
        bannerImgTop: '117.0666vw', // banner图距离上方高度(默认：65.0666vw)，vw单位，计算：按照设计图375，(像素尺寸)*100/375
        backgroundStyle: {}, // 背景模块样式,对象参数 nio summer: backgroundImage: 'linear-gradient(#00bdbd, #fff3e4)',height: '100vh',width: '100vw'
        backUrl: '', // 成功回调页面
        formTitle: '欢迎体验蔚来', // 表单title
        buttonText: '立即提交', // 按钮文案
        inviterChannel: '', // 涟漪邀请channel
        fellowEmpDomain: undefined, // leads归属fellow
        registerEmpDomain: undefined, // 留资fellow
        isFormItemRow: true, // 表单行展示
        isHidderName: true, // 隐藏name字段
        isHidderCar: false, // 隐藏car字段
        isHidderConfigurator: false, // 隐藏配置器
        isHidderInviter: false, // 隐藏邀请人信息
        isHidderInvitationCode: false, // 隐藏邀请码
        isHidderMoreIcon: false, // 隐藏更多按钮
        isAgree: false,
        nickname: '', // 用户昵称
        carModel: DEFAULT_CAR_MODEL,
        eventTrackSubmit: 'niosummer_join_click', // 提交埋点key
        eventTrackJoin: '', // 进入埋点key
        uniqueKey: '' // url 参数 unique_key
    },
    isAgree: false,
    // 是否nioapp打开
    isNIOApp: false,
    showCustomHeader: false,
    // 当前车型
    carType: 'es7',
    // 敬请期待
    comingSoon: false,
    // 成功页面 0:未成功，1成功，2参与过
    successStatus: 0,
    // 访问时间
    accessTime: new Date().getTime(),
    ...state
};

const tempMutations = {
    setRedirectUrl(state, data) {
        state.redirectUrl = data;
    },
    setPageOption(state, data) {
        state.pageOption = _.merge(state.pageOption, data);
        // 兼容参数
        const { userAccount, accountId } = state.pageOption;
        if (data.carModel) {
            state.pageOption.carType = data.carModel.toLowerCase();
            state.pageOption.carModel = data.carModel.toLowerCase();
            state.carType = data.carModel;
        }
        if (userAccount && !accountId) {
            state.pageOption.accountId = userAccount;
        }
        if (typeof data.isAgree === 'boolean') {
            state.pageOption.isAgree = data.isAgree;
            state.isAgree = data.isAgree;
        }
        // 临时兼容招行H5留资活动页
        if (data.campaignSourceCode === 'aCFNjtflcc') {
            state.pageOption.isHidderInvitationCode = true;
        }
        state.carType = (state.pageOption.carType || 'es7').toLowerCase();
        console.log('state.pageOption', state.pageOption);
    },
    setAccessTime(state, data) {
        state.accessTime = data;
    },
    setIsNIOApp(state, data) {
        state.isNIOApp = data;
    },
    setShowCustomHeader(state, data) {
        state.showCustomHeader = data;
    },
    setIsAgree(state, data) {
        state.isAgree = data;
    },
    setCarType(state, data) {
        state.carType = (data || 'es7').toLowerCase();
    },
    setSuccessStatus(state, data) {
        state.successStatus = data;
    },
    setComingSoon(state, data) {
        state.comingSoon = data;
    },
    ...mutations
};

const tempActions = {
    /** 页面迁移 重定向 */
    async decideIfRedirectToNewPage({ dispatch, commit, state }, param) {
        try {
            const routeParams = {
                accountId: param.accountId,
                carModel: param.carModel,
                campaignSourceCode: param.campaignSourceCode,
                inviterChannel: param.inviterChannel,
                activityId: param.activityId
            };
            const uniqueKeyRes = await dispatch('decodeUniqueKey', {
                key: param.key,
                host: param.host
            });

            let uniqueKeyContent = {};

            try {
                uniqueKeyContent = JSON.parse(uniqueKeyRes.data);
            } catch (error) {
                console.log('解析uniqueKey失败', error);
            }

            const {
                campaignSourceCode,
                campaignCode,
                carType,
                carModel,
                accountId,
                userAccount,
                inviterChannel,
                fellowEmpDomain,
                registerEmpDomain,
                activityId
            } = humps.camelizeKeys({
                ...routeParams,
                ...uniqueKeyContent
            });

            // 车型转换
            const { data: carTypeConfig } = await dispatch(
                'configCarV2',
                { mode: 'leads', host: param.host },
                { root: true }
            );
            const carTypeLowerCase = (carType ||
                carModel ||
                'ES7'
            ).toLowerCase();
            const realCarType = (carTypeConfig[carTypeLowerCase].carType ||
                carTypeLowerCase
            ).toUpperCase();

            const params = {
                campaignCode: campaignSourceCode || campaignCode,
                carType: realCarType,
                inviterAccountId: accountId || userAccount,
                inviterChannel: inviterChannel || INVITATION_CHANNEL_CODE.page,
                inviterBrand: 'nio',
                fellowEmpDomain,
                registerEmpDomain,
                activityId
            };

            const { data: scene } = await dispatch('encodeLeadsUniqueKey', {
                ...params,
                host: param.host
            });

            const host = UrlConfig['apollo'][param.env];
            const newLeadsPage = `${host}/hana-pro/pages/leads`;
            const targetLink = buildUrlWithQuery(newLeadsPage, { scene });

            commit('setRedirectUrl', targetLink);

            return true;
        } catch (e) {
            console.error(
                '[Leads decideIfRedirectToNewPage] load error => ',
                e.message
            );
        }
    },
    ...actions
};

const tempGetters = {
    campaignCode(state) {
        const pCode = state.pageOption.campaignSourceCode;
        const dCode = state.getCompatibleCodeData.campaign_code.appDrive;
        return pCode || dCode || '';
    }
};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations,
    getters: tempGetters
};
export default store;



// WEBPACK FOOTER //
// ./src/store/leads.js